


















































































































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import StarRatingComponent from '@/components/profile/StarRating.vue';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';
import {Member, MemberInitState, PersonEmergencies} from '@/store/member/member.types';
import BoxTextComponent from '@/components/profile/BoxText.vue';
import HistorySelfComponent from '@/components/profile/HistorySelf.vue';
import {FilesInitState, FileType, ReferenceID} from '@/store/files/files.types';
import BgTheme1 from '@/components/bg-theme-1.vue';
import {BaseDocument} from '@/store/type';
import {Branch} from '@/store/branch/branch.types';
import {Community, CommunityInitState, FilterCommunity} from '@/store/community/community.types';

@Component({
  components: {
    StarRatingComponent,
    BoxTextComponent,
    HistorySelfComponent,
    BgTheme1
  }
})
export default class ProfileComponent extends Vue {

  @State('member') memberInitState!: MemberInitState;
  @State('file') filesInitState!: FilesInitState;
  @State('community') communityInitState!: CommunityInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getByBranchId', {namespace: 'branch'}) getByBranchId!: (payload: string) => Promise<Branch>;
  @Action('_getMemberById', {namespace: 'member'}) getMemberById!: (payload: string) => Promise<void>;
  @Action('_getBondsmanById', {namespace: 'member'}) getBondsmanById!: (payload: string) => Promise<void>;
  @Action('_getTimeInformationById', {namespace: 'member'}) getTimeInformationById!: () => Promise<void>;
  @Action('_getProfile', {namespace: 'file'}) getProfile!: (payload: ReferenceID) => Promise<void>;
  @Action('_getStarByMemberId', {namespace: 'member'}) getStarByMemberId!: (id: string) => Promise<string>;
  @Action('_getProvincesById', {namespace: 'address'}) getProvincesById!: (payload: string) => Promise<void>;
  @Action('_getDistrictsById', {namespace: 'address'}) getDistrictsById!: (payload: string) => Promise<void>;
  @Action('_getAmphuresById', {namespace: 'address'}) getAmphuresById!: (payload: string) => Promise<void>;
  @Action('_getCommunityForRegister', {namespace: 'community'}) getCommunityForRegister!: (payload: FilterCommunity) => Promise<void>;

  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
  public member = {} as Member;
  public bondsman = {} as Member;
  public timeInformation = '0';
  public profile = '';
  public education = '';
  public branch = {} as Branch;
  public community = {communityName: 'ไม่มี'} as Community;
  public communityList = [{id: ''}] as Community[];

  public strRdy: boolean = false;

  async mounted() {
    await this.Loading(true);
    await this.getMemberById(this.loginInfo.id);
    await this.getTimeInformationById();
    this.timeInformation = this.memberInitState.timeTotal;
    this.member = await this.memberInitState.profile;
    if (this.member.bondsmanId) {
      await this.getBondsmanById(this.member.bondsmanId);
      this.bondsman = await this.memberInitState.bondsman;
    }

    if (this.member.personEmergencies.length === 0) {
      this.member.personEmergencies.push({
        firstName: '',
        lastName: '',
        mobilePhone: '',
        memberId: this.member.id
      } as PersonEmergencies)
    }



    this.branch = await this.getByBranchId(this.member.branchId);
    await this.getCommunity();
    await this.getMemberProfile();
    await this.Provinces();
    await this.Districts();
    await this.Amphures();
    await this.getStarByMemberId(this.member.id || '');
    this.strRdy = true;
    await this.Loading(false);
  }

  traEducation(text:string) {
    if(text === 'lessThen') {
      return 'ปริญญาตรีหรือต่ำกว่า';
    }else if (text === 'moreThen') {
      return 'สูงกว่าปริญญาตรี';
    }else {
      return '';
    }
  }

  async getMemberProfile() {
    await this.getProfile({
      private: true,
      fileType: FileType.thumbnail,
      refId: this.member.profile
    });
    if (this.filesInitState.profile.length !== 0) {
      this.profile = this.filesInitState.profile[0].filePath;
    } else {
      this.profile = 'https://timebank-spaces.sgp1.digitaloceanspaces.com/b9e40a46-7e70-4394-a93e-bd9b04ec3ef2.jpg'
    }
  }

  async getCommunity() {
    if (this.member.branchId !== '') {
      await this.getCommunityForRegister({branchId: this.member.branchId} as FilterCommunity);
      this.communityList = this.communityInitState.community;
      if (this.member.communityId !== '' || this.member.communityId !== null) {
        let com = await this.communityList.find((row) => row.id === this.member.communityId) as Community;
        if (com !== undefined) {
          this.community = com;
        }
      }

    }
  }

  traGender(value: string) {
    return value === 'male' ? 'ชาย' : 'หญิง'
  }

  async Provinces() {
    let currentProvinces = await this.getProvincesById(this.member.currentProvinces);
    // @ts-ignore
    this.member.currentProvinces = currentProvinces;

  }

  async Districts() {
    let currentDistricts = await this.getDistrictsById(this.member.currentDistricts);
    // @ts-ignore
    this.member.currentDistricts = currentDistricts;
  }

  async Amphures() {
    let currentAmphures = await this.getAmphuresById(this.member.currentAmphures);
    // @ts-ignore
    this.member.currentAmphures = currentAmphures;
  }


}
